<template>
  <div class="custom-element-wrapper">
    <div class="job-element" v-if="msgType === 'job'">
      <div class="tip">
        <icon-font type="job" />
        <span>职位信息</span>
      </div>
      <a-row
        type="flex"
        justify="space-between"
        align="middle"
        style="padding-bottom: 5px"
      >
        <a-col class="flex" span="19">
          <span class="name ellipsis">
            <b>{{ msgPayload.name }}</b>
          </span>
          <span class="ji" v-if="msgPayload.is_urgent == '1'">急</span>
          <span class="hc" v-if="msgPayload.is_mhc == '1'">多HC</span>
        </a-col>
        <a-col>
          <a-button
            size="small"
            type="primary"
            ghost
            @click="viewJob(msgPayload)"
            >查看</a-button
          >
        </a-col>
      </a-row>
      <a-row>
        <a-col>
          <b>
            <span style="color: #fc5646">
              {{
                `${msgPayload.hunter_salary_min}-${msgPayload.hunter_salary_max}万`
              }}
            </span>
          </b>
          <a-divider type="vertical" />
          <span>{{ msgPayload.city_name || msgPayload.province_name }}</span>
          <a-divider type="vertical" />
          <span>{{ msgPayload.education_name }}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="ellipsis">
          <span>{{ msgPayload.second_category_name }}</span>
          <a-divider type="vertical" />
          <span>{{
            msgPayload.company == undefined ? "" : msgPayload.company.name
          }}</span>
        </a-col>
      </a-row>
    </div>
    <div class="qrcode-element" v-else-if="msgType === 'pic'">
      <img :src="msgPayload.text" alt="" style="max-width: 100%" />
    </div>
    <div class="qrcode-element" v-else-if="msgType === 'meeting_live'">
      <div
        style="
          width: 314px;
          height: 120px;
          background: #ffffff;
          position: relative;
          cursor: pointer;
        "
        @click="linkgo(msgPayload.type, msgPayload.id)"
      >
        <img
          style="
            width: 100px;
            height: 100px;
            object-fit: cover;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 10px;
          "
          :src="msgPayload.thumbImg"
          alt=""
        />
        <p
          style="
            position: absolute;
            top: 10px;
            width: 184px;
            left: 120px;
            font-size: 18px;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
        >
          {{ msgPayload.title }}
        </p>
        <p
          style="
            position: absolute;
            top: 35px;
            width: 184px;
            left: 120px;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: box;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          "
        >
          {{ msgPayload.desc }}
        </p>
        <p
          style="
            position: absolute;
            bottom: 10px;
            width: 184px;
            left: 120px;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: box;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin: 0;
          "
        >
          ￥{{ msgPayload.salePrice }}
        </p>
      </div>
    </div>
    <div class="qrcode-element" v-else-if="msgType === 'attachment'">
      <a
        target="_blank"
        :href="msgPayload.file_url"
        class="resume_all"
        style="
          width: 251px;
          height: 71px;
          display: flex;
          border-radius: 7px;
          justify-content: space-between;
          align-items: center;
          background: #fff;
        "
      >
        <img
          style="width: 39px; height: 43px; margin:0 6px"
          :src="icon[msgPayload.file_ext] || '/misc/images/user/unknown.png'"
        />
        <div
          style="
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-right:6px
          "
        >
          {{ msgPayload.file_name }}
        </div>
      </a>
    </div>
    <span class="text" v-else>{{ text }}</span>
  </div>
</template>

<script>
import Api from "@/api";
export default {
  name: "CustomElem",
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon: {
        pdf: require("@/assets/pdf.png"),
        word: require("@/assets/word.png"),
        txt: require("@/assets/pdf.png"),
      },
    };
  },
  inject: ["closeConversation"],
  computed: {
    text() {
      return this.translateCustomMessage(this.payload);
    },
    msgType() {
      let data = this.jsonParse(this.payload.data);
      console.log(data);
      return data.type ? data.type : data;
    },
    msgPayload() {
      let data = this.jsonParse(this.payload.data);
      if (data.type) {
        if (data.type == "attachment") {
          //  this.getResume(data.attachment_id).then(res=>{
          return data;
          // })
        } else {
          return JSON.parse(data.data);
        }
      } else {
        return this.payload;
      }
    },
  },
  methods: {
    linkgo(where, id) {
      if (where == "1") {
        window.open("https://admin.lucasgchr.com/live/form?id=" + id);
      } else {
        window.open("https://admin.lucasgchr.com/live/meeting-form?id=" + id);
      }
    },
    getResume(id) {
      let params = {
        attachment_id: id,
      };
      return Api.im.getResumeAttachment(params).then((res) => {
        if (res) {
          let attachment = res.attachment;

          return attachment;
        }
      });
    },
    translateCustomMessage(payload) {
      if (payload.data === "group_create") {
        return `${payload.extension}`;
      }
      return "[自定义消息]";
    },
    jsonParse(str) {
      try {
        let val = JSON.parse(str);
        return val;
      } catch (e) {
        return str;
      }
    },
    viewJob(record) {
      this.closeConversation();
      this.$router.push(`/post-detail/${record.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.job-element {
  width: 314px;
  padding: 8px 16px;
  background: #fff;
  color: #666;
  .tip {
    color: #999;
    font-size: 18px;
    line-height: 30px;
    span {
      margin-left: 10px;
      font-size: 12px;
      position: relative;
      top: -2px;
    }
  }
  .flex {
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      margin-right: 5px;
      &.name {
        font-size: 16px;
        font-weight: bold;
        color: #333;
      }
      &.ji {
        font-size: 12px;
        background: #ff6b5d;
        border-radius: 2px;
        height: 18px;
        color: #fff;
        padding: 0 3px;
      }
      &.hc {
        background: #f6b502;
        padding: 0 3px;
        font-size: 12px;
        border-radius: 2px;
        height: 18px;
        color: #fff;
      }
    }
  }
  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .resume_all {
  }
}
</style>
